import { useState } from 'react';
import { Box, Table, TableBody, TableHead, TableRow } from '@mui/material';
import {
  GeneralTableBox,
  HeadTableCell,
  RowTableCell,
  PaginationTable,
  ActionIconButton,
  ConfirmationDialog,
} from '../../common/components';

import { formatCurrency, formatDate, formatPercentage } from '../utils/plansUtils';

/**
 * Componente de tabla de datos para planes
 * Reutiliza componentes del common siguiendo los patrones del proyecto
 */
const PlansDataTable = ({
  plans,
  totalPlans,
  page,
  totalPages,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  onEdit,
  onDelete,
  isLoading,
  LoadingComponent,
}) => {
  const [deleteDialog, setDeleteDialog] = useState({
    open: false,
    planId: null,
    planUuid: null,
    planInfo: null,
  });

  const handleDeleteClick = (planId, planUuid, plan) => {
    setDeleteDialog({
      open: true,
      planId,
      planUuid,
      planInfo: plan,
    });
  };

  const handleDeleteCancel = () => {
    setDeleteDialog({
      open: false,
      planId: null,
      planUuid: null,
      planInfo: null,
    });
  };

  const handleDeleteConfirm = () => {
    if (deleteDialog.planId && deleteDialog.planUuid) {
      onDelete(deleteDialog.planId, deleteDialog.planUuid);
      handleDeleteCancel();
    }
  };

  if (isLoading) {
    return <LoadingComponent />;
  }

  return (
    <Box>
      <GeneralTableBox>
        <Table aria-label="plans table">
          <TableHead>
            <TableRow>
              <HeadTableCell wmd="100%">Nombre</HeadTableCell>
              <HeadTableCell wxs="13%">Fecha inicio vig.</HeadTableCell>
              <HeadTableCell wxs="13%">Fecha baja</HeadTableCell>
              <HeadTableCell wxs="10%">Cant. de cuotas</HeadTableCell>
              <HeadTableCell wxs="10%">Cant. de contrat.</HeadTableCell>
              <HeadTableCell wxs="12%">Interes x Def.(%)</HeadTableCell>
              <HeadTableCell wxs="15%">1er Valor Cuota($)</HeadTableCell>
              <HeadTableCell wxs="15%">Acciones</HeadTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {plans.map((plan, key) => (
              <TableRow key={key}>
                <RowTableCell>{plan.name}</RowTableCell>
                <RowTableCell>{formatDate(plan.effective_start_date)}</RowTableCell>
                <RowTableCell>{formatDate(plan.finish_date) || '-'}</RowTableCell>
                <RowTableCell>{plan.installments_number}</RowTableCell>
                <RowTableCell>{plan.contracts_number}</RowTableCell>
                <RowTableCell>{formatPercentage(plan.interest_rate)}</RowTableCell>
                <RowTableCell>{formatCurrency(plan.first_installment_amount)}</RowTableCell>
                <RowTableCell sx={{ textAlign: 'center' }}>
                  <ActionIconButton variant="edit" onClick={() => onEdit(plan)} />
                  <ActionIconButton variant="delete" onClick={() => handleDeleteClick(plan.id, plan.uuid, plan)} />
                </RowTableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>

        {totalPlans > rowsPerPage && (
          <PaginationTable
            totalPages={totalPages}
            page={page}
            rowsPerPage={rowsPerPage}
            onPageChange={onPageChange}
            onRowsPerPageChange={onRowsPerPageChange}
            totalCount={totalPlans}
          />
        )}
      </GeneralTableBox>

      <ConfirmationDialog
        open={deleteDialog.open}
        onClose={handleDeleteCancel}
        onConfirm={handleDeleteConfirm}
        title="Eliminar Plan"
        message={`¿Está seguro que desea eliminar el plan "${deleteDialog.planInfo?.description || 'seleccionado'}"?`}
        confirmText="Eliminar plan"
      />
    </Box>
  );
};

export default PlansDataTable;
